document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    initStickyAddToCart();
  }, 500);

  function initStickyAddToCart() {
    const stickyElement = document.getElementById('stickyAddToCart');
    if (!stickyElement) return;

    // ── Read settings from data attributes (set by Liquid) ──────────────────
    const scrollThresholdPx = parseInt(stickyElement.dataset.scrollThreshold, 10) || 400;
    const scrollTargetPx    = parseInt(stickyElement.dataset.scrollTarget, 10)    || 600;
    const addToCartMode     = stickyElement.dataset.addToCartMode === 'true';

    // ── Find the main add-to-cart button ─────────────────────────────────────
    const addToCartSelectors = [
      'button[name="add"]',
      'button.add-to-cart',
      'button.add-to-cart-button',
      'button.product-form__cart-submit',
      'button.product-form__submit',
      'form[action*="/cart/add"] button[type="submit"]',
      '.ProductForm__AddToCart'
    ];

    let addToCartButton = null;

    for (const selector of addToCartSelectors) {
      const btn = document.querySelector(selector);
      if (btn) { addToCartButton = btn; break; }
    }

    if (!addToCartButton) {
      const observer = new MutationObserver(function() {
        for (const selector of addToCartSelectors) {
          const btn = document.querySelector(selector);
          if (btn) {
            addToCartButton = btn;
            observer.disconnect();
            setupScrollHandler();
            break;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
    } else {
      setupScrollHandler();
    }

    // ── Scroll show/hide logic ────────────────────────────────────────────────
    function setupScrollHandler() {
      let isVisible   = false;
      let debounceTimer = null;

      function isCartOpen() {
        const cartDrawerWrapper = document.querySelector('cart-drawer.drawer, .drawer.cart-drawer, .cart-drawer');
        const cartSidebar       = document.querySelector('#sidebar-cart, #CartDrawer, .cart-sidebar');
        return (
          (cartDrawerWrapper && (
            cartDrawerWrapper.classList.contains('active') ||
            cartDrawerWrapper.classList.contains('is-open') ||
            cartDrawerWrapper.classList.contains('drawer--is-open') ||
            cartDrawerWrapper.hasAttribute('open') ||
            cartDrawerWrapper.getAttribute('aria-hidden') === 'false'
          )) ||
          (cartSidebar && (
            cartSidebar.classList.contains('is-open') ||
            cartSidebar.classList.contains('drawer--is-open') ||
            cartSidebar.getAttribute('aria-hidden') === 'false'
          ))
        );
      }

      function handleScroll() {
        // Respect visibility-hiding settings
        const desktopShipping = document.querySelector('.sticky-add-to-cart__shipping');
        const mobileShipping  = document.querySelector('.mobile-shipping-info');
        if (desktopShipping && window.stickySettings) {
          if (window.stickySettings.showDesktopShipping === false || window.stickySettings.showDeliveryDate === false) {
            desktopShipping.style.display = 'none';
            desktopShipping.setAttribute('aria-hidden', 'true');
          }
        }
        if (mobileShipping && window.stickySettings) {
          if (window.stickySettings.showMobileShipping === false || window.stickySettings.showDeliveryDate === false) {
            mobileShipping.style.display = 'none';
            mobileShipping.setAttribute('aria-hidden', 'true');
          }
        }

        if (isCartOpen()) { hideStickyButton(); return; }

        // Show bar once page has scrolled past scrollThresholdPx
        const scrolled        = window.scrollY || window.pageYOffset;
        const shouldBeVisible = scrolled >= scrollThresholdPx;

        if (shouldBeVisible !== isVisible) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            if (shouldBeVisible) {
              showStickyButton();
            } else {
              hideStickyButton();
            }
          }, 50);
        }
      }

      function showStickyButton() {
        if (isVisible) return;
        stickyElement.style.display = 'block';
        void stickyElement.offsetWidth; // force reflow for transition
        stickyElement.classList.add('show');
        isVisible = true;
      }

      function hideStickyButton() {
        if (!isVisible) return;
        stickyElement.classList.remove('show');
        setTimeout(() => {
          if (!stickyElement.classList.contains('show')) {
            stickyElement.style.display = 'none';
          }
          isVisible = false;
        }, 400);
      }

      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleScroll, { passive: true });

      // Re-check when cart drawer opens/closes
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-action="open-drawer"], [data-open-cart], .js-drawer-open-cart, .cart-link')) {
          setTimeout(handleScroll, 100);
        }
      });
      document.addEventListener('cart:open',          handleScroll);
      document.addEventListener('cart-drawer:open',   handleScroll);
      document.addEventListener('cart.requestStarted',handleScroll);
      document.addEventListener('cartDrawerOpened',   handleScroll);

      const drawerObserver = new MutationObserver(function(mutations) {
        for (let m of mutations) {
          if (m.type === 'attributes' && ['aria-hidden','class','open'].includes(m.attributeName)) {
            handleScroll();
          }
        }
      });
      document.querySelectorAll('cart-drawer, #sidebar-cart, #CartDrawer, .cart-drawer')
        .forEach(d => drawerObserver.observe(d, { attributes: true }));

      setTimeout(handleScroll, 300);
      setInterval(handleScroll, 2000);
    }

    // ── Button click handler ─────────────────────────────────────────────────
    function handleButtonClick(event) {
      event.preventDefault();

      if (addToCartMode) {
        // ── Mode 1: Add to cart ──────────────────────────────────────────────
        // Try clicking the real ATC button on the page (triggers Shopify's own logic)
        if (addToCartButton) {
          addToCartButton.click();
        } else {
          // Fallback: submit the first product form
          const productForm = document.querySelector('form[action*="/cart/add"]');
          if (productForm) productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      } else {
        // ── Mode 2: Scroll to bundle/quantity section ────────────────────────
        window.scrollTo({ top: scrollTargetPx, behavior: 'smooth' });
      }
    }

    // Attach handler to both desktop and mobile sticky buttons
    ['stickyAddToCartBtn', 'stickyAddToCartBtnMobile'].forEach(function(id) {
      const btn = document.getElementById(id);
      if (btn) {
        // Remove inline onclick set in HTML, replace with our handler
        btn.removeAttribute('onclick');
        btn.addEventListener('click', handleButtonClick);
      }
    });
  }

  // Keep legacy global for any inline onclick references still in the template
  window.scrollToTop = function(event) {
    if (event) event.preventDefault();
    const el = document.getElementById('stickyAddToCart');
    const target = el ? (parseInt(el.dataset.scrollTarget, 10) || 600) : 600;
    window.scrollTo({ top: target, behavior: 'smooth' });
  };
});
